import React, { Component } from 'react';

import AuthContext from '../../contexts/AuthContext';

import Spinner from '../../components/UI/Spinner';
import Modal from '../../components/UI/Modal';
import SettingsWindow from '../../components/Account/SettingsWindow';

import ChangePassword from '../Auth/ChangePassword';
import Interest from './Interest';
import ProfilePicture from './ProfilePicture';


class Account extends Component {

    static contextType = AuthContext;

    state = {
        isLoading: false,
        error: null,
        settingsWindowOpen: false,
        activeSetting: { id: 'account-setting#1', title: 'My Interests', icon: "fa fa-heart", component: <Interest /> },
        settings: [
            { id: 'account-setting#1', title: 'My Interests', icon: "fa fa-heart", component: <Interest /> },
            { id: 'account-setting#2', title: 'Profile Picture', icon: "fas fa-portrait", component: <ProfilePicture /> },
            { id: 'account-setting#3', title: 'Change Password', icon: "fa fa-key", component: <ChangePassword /> },
        ]
    }

    settingClickHandler = id => {
        this.setState({
            activeSetting: this.state.settings.find(setting => setting.id === id)
        });
    }

    settingsWindowOpenHandler = () => {
        this.setState({ settingsWindowOpen: true });
    }

    settingsWindowCloseHandler = () => {
        this.setState({ settingsWindowOpen: false });
    }

    modalCloseHandler = () => {
        this.setState({ error: null });
    }

    render() {
        let accountModule = (
            <div className="account-module">

                <Modal show={this.state.error !== null} title="An error occurred!" closed={this.modalCloseHandler} >
                    {this.state.error && <p>{this.state.error.status}: {this.state.error.message}</p>}
                </Modal>

                <div className="settings-header">
                    <button className="settings-window-toggle" onClick={this.settingsWindowOpenHandler}>
                        <i className="fa fa-cog" aria-hidden="true"></i>
                    </button>
                </div>

                <SettingsWindow
                    settings={this.state.settings}
                    open={this.state.settingsWindowOpen}
                    activeSetting={this.state.activeSetting && this.state.activeSetting.id}
                    clicked={this.settingClickHandler}
                    closed={this.settingsWindowCloseHandler} />

                <div className="settings-area">
                    {this.state.activeSetting && this.state.activeSetting.component}
                </div>

            </div>
        );

        if (this.state.isLoading) {
            accountModule = <Spinner />;
        }

        return accountModule;
    }
}

export default Account;